import { render, staticRenderFns } from "./addAssignee.vue?vue&type=template&id=598827ae&scoped=true&"
import script from "./addAssignee.vue?vue&type=script&lang=js&"
export * from "./addAssignee.vue?vue&type=script&lang=js&"
import style0 from "./addAssignee.vue?vue&type=style&index=0&id=598827ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598827ae",
  null
  
)

export default component.exports